import { render, staticRenderFns } from "./RestaurantActions.vue?vue&type=template&id=6c2e8e22&scoped=true"
import script from "./RestaurantActions.vue?vue&type=script&lang=js"
export * from "./RestaurantActions.vue?vue&type=script&lang=js"
import style0 from "./RestaurantActions.vue?vue&type=style&index=0&id=6c2e8e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e8e22",
  null
  
)

export default component.exports